import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationModel } from '../../../models/notification.model';
import { NotificationType } from '../../../models/notification-type.enum';

@Component({
  selector: 'app-notification-tile',
  templateUrl: './notification-tile.component.html',
  styleUrls: ['./notification-tile.component.scss'],
})
export class NotificationTileComponent implements OnInit {
  @Input() notification: NotificationModel;
  @Output() staffNotificationClicked = new EventEmitter<number[]>();


  notificationTitles: { [key: number]: string } = {
    1: 'New student assignment',
  };

  get currentLang() {
    return this._translator.currentLang;
  }

  constructor(private _translator: TranslateService) { }

  ngOnInit(): void { }

  @HostListener('click')
  onStaffNotificationClicked(): void {
    if (this.notification.type !== NotificationType.StaffCaseloadAssignment) {
      return;
    }
    this.staffNotificationClicked.emit();
  }

}

